import { Component, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { BulkEditAction } from '../../services/events.service';

@Component({
  selector: 'app-edit-bulk',
  templateUrl: './edit-bulk.component.html',
  styleUrls: ['./edit-bulk.component.css'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BoDialogComponent,
    ButtonComponent,
  ],
})
export class EditBulkComponent {
  private dialogRef = inject<BrnDialogRef<BulkEditAction>>(BrnDialogRef);
  private formBuilder = inject(FormBuilder);

  readonly eventDescriptions = input.required<string[]>();
  protected form: FormGroup<{ action: FormControl<BulkEditAction | null> }> =
    this.formBuilder.group({
      action: this.formBuilder.control<BulkEditAction | null>(null, [
        Validators.required,
      ]),
    });

  public onDismiss() {
    this.dialogRef.close();
  }

  public onConfirm() {
    const action = this.form.getRawValue().action;

    if (!action) {
      return;
    }
    this.dialogRef.close(action);
  }
}
